import IncidentsList from '~/incidents/list';

IncidentsList();
